import { useReduxState } from 'hooks';
import { getDefaultTextHighlightColors } from 'lib/colors';
import { Button } from 'components/common';
import {
  ArrayField,
  ColorPicker,
  FormGroup,
  FormSection
} from 'components/common/form';

interface Props {
  field: string;
  formState: any;
}

const SiteSettingsThemesEditHighlight = ({ field, formState }: Props) => {
  const { messages } = useReduxState();

  const defaultOptions = getDefaultTextHighlightColors(
    formState.values.data || {}
  );

  return (
    <FormSection
      isExpandable={false}
      maxWidth="100%"
      title="Text highlight colors"
      helpText="If you add options they will override the default options. It is recommended that you add either background color or border color for each option, but not both for the same option."
    >
      <div className="preview-item" style={{ marginBottom: 10 }}>
        {(formState.values.data?.textHighlightColors || defaultOptions).map(
          (option, i) => (
            <div
              key={i}
              style={{
                backgroundColor: option.backgroundColor || 'transparent',
                border: option.borderColor
                  ? `2px solid ${option.borderColor}`
                  : 'none',
                borderRadius: 5,
                color: option.color,
                display: 'inline-block',
                fontSize: '1.4rem',
                fontWeight: 600,
                margin: '0 10px 10px 0',
                padding: option.borderColor ? '0px 5px' : '2px 7px'
              }}
            >
              {messages.commonText}
            </div>
          )
        )}
      </div>
      <ArrayField field={field}>
        {({ add }) => (
          <>
            <ArrayField.Items>
              {({ remove, field, index, values }) => (
                <div className="row row-bottom">
                  <div className="col-1of4">
                    <FormGroup label="color">
                      <ColorPicker field={`${field}.color`} />
                    </FormGroup>
                  </div>
                  <div className="col-1of4">
                    <FormGroup label="backgroundColor">
                      <ColorPicker field={`${field}.backgroundColor`} />
                    </FormGroup>
                  </div>
                  <div className="col-1of4">
                    <FormGroup label="borderColor">
                      <ColorPicker field={`${field}.borderColor`} />
                    </FormGroup>
                  </div>
                  <div className="col-min">
                    <Button
                      aria-label={messages.commonDelete}
                      category="light"
                      data-tooltip={messages.commonDelete}
                      icon="trash-alt"
                      onClick={remove}
                      size="small"
                      style={{ margin: '4px 4px 4px -10px' }}
                    />
                  </div>
                </div>
              )}
            </ArrayField.Items>

            <Button
              category="light"
              icon="plus"
              onClick={add}
              size="small"
              style={{ marginTop: 15 }}
              text="Add option"
            />
          </>
        )}
      </ArrayField>
    </FormSection>
  );
};

export default SiteSettingsThemesEditHighlight;
